import axios from '../../axios'
import { GET_SMS_COUNT_REMAIN, GET_SMS_RELOAD_HISTORY, GET_SMS_COUNT } from './smsCountTypes'

import { URL_GET_SMS_COUNT_REMAIN, URL_GET_SMS_RELOAD_HISTORY, URL_GET_SMS_COUNT } from './smsCountUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
// import { dirname } from 'path'

export default {
  [GET_SMS_COUNT_REMAIN]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_SMS_COUNT_REMAIN, { params })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SMS_COUNT_REMAIN, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_SMS_RELOAD_HISTORY]({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_SMS_RELOAD_HISTORY, { params })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SMS_RELOAD_HISTORY, data);
              resolve(data.items);
            } else {
              commit(GET_SMS_RELOAD_HISTORY, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_SMS_RELOAD_HISTORY, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }

        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_SMS_COUNT]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_SMS_COUNT, { params })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SMS_COUNT, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
}
